import React from "react";

export function RequiredStar(props) {
    return (
        <span className="required no-print">*</span>
    )
}